import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero'; // Import the new component
import offer1 from '../assets/11062b_bcca276530a3448abd24d6a7dd979d8a~mv2.avif';
import offer2 from '../assets/21f4fa8ec14b42dda49143f442a327b3.avif';
import offer3 from '../assets/chess6.jpg';

import ParentTestimonials from '../components/ParentTestimonials';

import QA from '../components/QA';

const Chess = () => {
  return (
    <>
      <Hero />
      <div className="container text-center my-5">
        <h2 className="offer-title mb-5">What We Offer</h2>
        <div className="row">
          <div className="col-md-4">
            <div className="card offer-card h-100">
              <img src={offer1} className="card-img-top" alt="1 on 1 Chess Lesson" />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">1 on 1 Chess Lesson</h5>
                <p className="card-text">Fine-tune your chess strategy for success</p>
                <hr />
                <p className="card-text">1 hr</p>
                <p className="card-text fw-bold">$30</p>
                <Link to="/book/1-on-1-lesson" className="btn btn-book-now mt-auto">Book Now</Link>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card offer-card h-100">
              <img src={offer2} className="card-img-top" alt="Free Trial Class" />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Free Trial Class</h5>
                <p className="card-text">Book this class for free as your first trial class.</p>
                <hr />
                <p className="card-text">1 hr</p>
                <p className="card-text fw-bold">$0</p>
                <Link to="/book/free-trial" className="btn btn-book-now mt-auto">Book Now</Link>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card offer-card h-100">
              <img src={offer3} className="card-img-top" alt="Weekly Chess Lessons" />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Weekly Chess Lessons</h5>
                <p className="card-text">Elevate your chess game with consistent lessons.</p>
                <hr />
                <p className="card-text">1 hr</p>
                <p className="card-text fw-bold">$30</p>
                <Link to="/book/weekly-lessons" className="btn btn-book-now mt-auto">Book Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ParentTestimonials />
      <QA />
    </>
  );
};

export default Chess;